import { useCallback } from 'react'
import { useTranslation } from 'next-i18next'
import { useToast } from '@machobear/design-system'
import { useDispatch } from 'react-redux'

import {
  MessageChannelData,
  useMessageChannel
} from '@/hooks/use-message-channel'

export const useSignupMessage = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const showToast = useToast()

  const onMessageCallback = useCallback(
    (data: MessageChannelData) => {
      if (data.type === 'signup_success') {
        showToast({
          tone: 'positive',
          message: t('Account complete!'),
          description: t("You're ready for quicker replies and safe renting.")
        })
        dispatch.session.loadSession()
      }
    },
    [showToast, t, dispatch.session]
  )

  useMessageChannel({
    channelName: 'signup',
    onMessage: onMessageCallback
  })
}
